import { readable, writable, type Readable, type Writable } from "svelte/store";
import { initCalendarState } from "scripts/utils/date_utils";
import type { TableStatusVal, TypeCalendarState } from "scripts/utils/types";

export const calendarState: Writable<TypeCalendarState> = writable(initCalendarState())

export const initialTableStatusVal: Readable<TableStatusVal> = readable({ color: '', value: undefined })